import { connect } from 'react-redux';
import { saveWriterDeviation, publishWriterDeviation, resetWriterPopup, writerPopupClosed, } from './actions';
import { getWriterDeviation, getWriterError, getIsWriterSubmitting, getIsWriterDeviationFeatured, getIsRedirecting, } from './selectors';
import { WriterPopupType } from './types';
var mapStateToProps = function (state, props) {
    var deviation = getWriterDeviation(state) || props.deviation;
    var type = deviation
        ? deviation.isJournal
            ? WriterPopupType.JOURNAL
            : WriterPopupType.LITERATURE
        : props.type;
    return {
        error: getWriterError(state),
        isSubmitting: getIsWriterSubmitting(state),
        isRedirecting: getIsRedirecting(state),
        isFeatured: getIsWriterDeviationFeatured(state),
        deviation: deviation,
        type: type,
    };
};
var mapDispatchToProps = {
    saveWriterDeviation: saveWriterDeviation,
    publishWriterDeviation: publishWriterDeviation,
    resetWriterPopup: resetWriterPopup,
    writerPopupClosed: writerPopupClosed,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=WriterPopup.container.js.map